/* eslint-disable no-unused-vars */
import Ic from '../Icon';
export default function ProGate({ feature, onUpgrade }) {
  return (
    <div style={{textAlign:'center',padding:'64px 24px'}}>
      <div style={{width:64,height:64,borderRadius:'50%',background:'rgba(34,197,94,.08)',border:'1px solid rgba(34,197,94,.2)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 20px'}}>
        <Ic n="crown" s={28} c="#22c55e"/>
      </div>
      <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:900,color:'#fff',marginBottom:8}}>{feature}</div>
      <div style={{fontSize:14,color:'#8b949e',maxWidth:400,margin:'0 auto 28px',lineHeight:1.7}}>
        This feature is included in the <strong style={{color:'#4ade80'}}>Pro Plan</strong> at $49/mo. Upgrade to unlock it along with 5 other powerful tools.
      </div>
      <button className="btn btn-g" style={{padding:'12px 28px',fontSize:15}} onClick={onUpgrade}>
        <Ic n="crown" s={15}/>View Plans & Upgrade
      </button>
    </div>
  );
}
